<script setup>
import Datatable from '@/components/Shared/Table/Datatable.vue';
import { inject, ref } from 'vue';
import ConfirmDeleteModal from '@/components/Dashboard/ConfirmDeleteModal.vue';
import EditTeamMemberModal from '@/Pages/Dashboard/Account/Partials/Teams/EditTeamMemberModal.vue';
import { router } from '@inertiajs/vue3';

const trans = inject('trans');

const emit = defineEmits(['deleted', 'updated']);
const props = defineProps({
  teamMembers: {
    type: Array,
    required: true,
  },
  permissions: {
    type: Array,
    required: true,
  },
});
const headers = [
  { text: trans('common.email'), value: 'email', align: 'start' },
  { text: trans('common.name'), value: 'name', align: 'start' },
  { text: '', value: 'action', align: 'start' },
];

const memberToDelete = ref(null);
const memberToEdit = ref(null);

const showEditModal = teamMember => {
  memberToEdit.value = teamMember;
};

const showDeleteConfirmation = teamMember => {
  memberToDelete.value = teamMember;
};

const handleConfirmDeleteInvitation = () => {
  router.delete(route('dashboard.account.teams.team-member.destroy', { teamMember: memberToDelete.value.id }), {
    onSuccess: () => {
      emit('deleted', memberToDelete.value);
      memberToDelete.value = null;
    },
  });
};

const handleUpdated = () => {
  emit('updated');
  memberToEdit.value = null;
};
</script>

<template>
  <div>
    <datatable :headers="headers" :items="teamMembers" :loading="false">
      <template #item-name="{ item }">
        <div class="flex">
          <div>{{ item.name }}</div>
          <span v-if="item.isOwner">({{ trans('dashboard.account.teams.members.owner') }})</span>
        </div>
      </template>
      <template #item-action="{ item }">
        <div v-if="!item.isOwner && $can('teams.invite')" class="flex">
          <button class="tile-button" type="button" @click="showEditModal(item)">
            <svg class="icon">
              <use xlink:href="#edit-icon"></use>
            </svg>
          </button>
          <button
            class="tile-button delete"
            style="margin: 0.5rem auto"
            type="button"
            @click="showDeleteConfirmation(item)"
          >
            <svg class="icon">
              <use xlink:href="#delete-icon"></use>
            </svg>
          </button>
        </div>
      </template>
    </datatable>

    <confirm-delete-modal
      v-if="memberToDelete"
      :name="`delete-member-` + memberToDelete.id"
      :content="trans('dashboard.account.teams.members.delete_member_confirmation_description')"
      :header="trans('dashboard.account.teams.members.delete_member_confirmation_title')"
      @close="memberToDelete = null"
      @confirm="handleConfirmDeleteInvitation"
    />
    <edit-team-member-modal
      :team-member="memberToEdit"
      :permissions="permissions"
      @close="memberToEdit = null"
      @updated="handleUpdated"
    />
  </div>
</template>
